export const CHANGE_TITLE = 'CHANGE_TITLE';
